module.exports = ".panel {\n    margin: 20px 30px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/upload-view/upload-view.component.css
// module id = ./src/app/components/upload-view/upload-view.component.css
// module chunks = main